<div style="margin: 2rem">
  <table class="m-table" aria-label="Highlights" style="width: calc(100% - 1.5rem); padding-top: 1rem">
    <thead style="border-bottom: 1px solid black;">
    <tr>
      <th>
        <span class="table-header"> {{ "ASSET_SYNC.vin" | translate }} </span>
      </th>
      <th>
        <span class="table-header">{{ "ASSET_SYNC.rideCarePartnerID" | translate }} </span>
      </th>
      <th>
        <span class="table-header">{{ "ASSET_SYNC.geoTabSerialNumber" | translate }} </span>
      </th>
      <th>
        <span class="table-header">{{ "ASSET_SYNC.activationStatus" | translate }}</span>
      </th>
    </tr>
    </thead>
    <tbody>
      @for (asset of assets; track asset.vin) {
        <tr>
          <td><span> {{ asset?.vin }}</span></td>
          <td><span> {{ asset?.ridecareSerialNumber }}</span></td>
          <td><span> {{ asset?.goDeviceGeotabSerialNumber || asset?.ridecareDeviceGeotabSerialNumber }}</span></td>
          <td>
            <span>{{ getActivationStatusKey(asset) | translate }}</span>
            @if (shouldShowMissingSubscriptionInfo(asset)) {
              <div class="info-icon" [class.is-open]="activeInfoVin === asset?.vin">
                <button
                  type="button"
                  class="a-icon boschicon-bosch-ic-info-i-frame custom-link info-icon-trigger"
                  [attr.aria-label]="'ASSET_SYNC.subscriptionInfoAriaLabel' | translate"
                  [attr.aria-describedby]="'asset-sync-tooltip-' + $index"
                  (click)="toggleInfoTooltip(asset?.vin)"
                  (keydown.escape)="toggleInfoTooltip()"
                ></button>
                <div class="subscription-tooltip" role="tooltip" [id]="'asset-sync-tooltip-' + $index">
                  @for (messageKey of getMissingSubscriptionInfoKeys(asset); track messageKey) {
                    <p>{{ messageKey | translate }}</p>
                  }
                </div>
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  <div #scrollSentinel style="height: 10px; visibility: hidden;"></div>
</div>

<ngx-spinner
  [fullScreen]="true"
  bdColor="rgba(216,216,216,0.8)"
  [template]="spinnerTemplate"
></ngx-spinner>
